import React, { useContext, useEffect, useState } from 'react';
import { ApisauceInstance } from 'apisauce';
import Loading from '../../../components/Loading';
import CloudFunctionClientContext from 'contexts/CloudFunctionClientContext';
import AccountPickerContext from '../../../contexts/AccountPickerContext';
import buildCloudFunctionClient from '../../../services/buildCloudFunctionClient';
import VersionContext from '../../../contexts/VersionContext';
import AccountContext from '../../../contexts/AccountContext';

const CloudFunctionClientProvider = ({
  children,
  accountId,
}: {
  children: JSX.Element | JSX.Element[];
  accountId?: string;
}) => {
  const { buildNumber } = useContext(VersionContext);
  const [api, setapi] = useState<ApisauceInstance | undefined>();
  const { selectedAccount } = useContext(AccountPickerContext);
  const { timezone } = useContext(AccountContext);

  useEffect(() => {
    const currentAccountId = accountId
      ? accountId
      : selectedAccount === undefined
        ? undefined
        : selectedAccount.accountId === 'na'
          ? undefined
          : selectedAccount.accountId;

    setapi(
      buildCloudFunctionClient({
        accountId: currentAccountId,
        buildNumber,
        timezone,
      }),
    );
  }, [
    accountId,
    buildNumber,
    selectedAccount,
    selectedAccount.accountId,
    timezone,
  ]);

  if (!api) {
    return <Loading />;
  }

  return (
    <CloudFunctionClientContext.Provider value={{ api }}>
      {children}
    </CloudFunctionClientContext.Provider>
  );
};

export default CloudFunctionClientProvider;
